var Utils = {

  getMomentLocale: function() {
    let momentLocale = i18n.getCurrentLocale();

    // "ll" is a short date format: MMM DD, YYYY by default
    let momentFormat = "ll";

    // provide fallbacks for locales that aren't supported in moment.js
    if (momentLocale === "fil") {
      momentLocale = "tl-ph";
    } else if (momentLocale === "no") {
      momentLocale = "nb";
    }

    return {momentLocale, momentFormat};
  },

  delayTimeout: function(callback, timeoutLength, timeoutId){
    if (!this.delayTimeouts){ this.delayTimeouts = {}; }
    if (this.delayTimeouts[timeoutId]){
      clearTimeout(this.delayTimeouts[timeoutId]);
    }
    this.delayTimeouts[timeoutId] = setTimeout(callback, timeoutLength);
    return this.delayTimeouts[timeoutId];
  },

  throttle: function(callback, throttleAmount, timeoutLength, timeoutId){
    Fraction.Helpers.throttleArray = Fraction.Helpers.throttleArray || {};
    Fraction.Helpers.throttleArray[timeoutId] = Fraction.Helpers.throttleArray[timeoutId] || 0;
    Fraction.Helpers.throttleArray[timeoutId]++;
    if (Fraction.Helpers.throttleArray[timeoutId]%throttleAmount===0){
      callback();
    }
    return Fraction.Helpers.delayTimeout(callback, timeoutLength, timeoutId);
  },

  // Generate a somewhat unique identifier
  // http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
  generateGUID: function(){
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
      s4() + '-' + s4() + s4() + s4();
  },

  shuffleArray: function(array) {
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
    return array;
  },

  // Get the current timestamp
  getUnixTimestamp: function(){
    return (new Date()).getTime();
  },

  copyText: function(text){
    if (document.queryCommandSupported('copy') && text.length>0){
      var copyTextDiv = $("<div class='copytext' style='background:transparent;' aria-hidden='true'>"+text+"</div>");
      $("#bookshelf").append(copyTextDiv);
      copyTextDiv = copyTextDiv.get(0);
      var range = document.createRange();
      range.selectNode(copyTextDiv);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      copyTextDiv.parentNode.removeChild(copyTextDiv);
      return true;
    } else {
      return false;
    }
  },

  copyEnabled: function(){
    if (Fraction.Helpers.canCopy){
      return true;
    } else {
      try {
        Fraction.Helpers.canCopy = (document.queryCommandEnabled('copy') || document.queryCommandSupported('copy'));
        return Fraction.Helpers.canCopy;
      } catch(e) {
        return false;
      }
    }
  },

  // Bind links to use the router as opposed to actually linking places
  bindLinks: function(){
    $("a[bound!='bound']").each(function(e){
      if (!Fraction.Helpers.isExternalURL(this)){
        $(this).attr("bound", "bound");
        $(this).on('click', function(e){
          e.preventDefault();
          if (this.href.indexOf("#")!==-1){
            Fraction.Router.setRoute(this.hash.replace("#",""));
          } else {
            Fraction.Router.setRoute($(this).attr("href"));
          }
        });
      }
    });
  },

  passwordInputShim: function(){
    /* Added function below as fix to render the Password placeholder as text and not dots for IE9 */
    var input = document.createElement("input");
    var i;
    if (!('placeholder' in input)) {
      $('[placeholder]').focus(function () {
        var i = $(this);
        if (i.val() === i.attr('placeholder')) {
          i.val('').removeClass('placeholder');
          if (i.hasClass('password')) {
            i.removeClass('password');
            this.type = 'password';
          }
        }
      }).blur(function () {
        i = $(this);
        if (i.val() === '' || i.val() === i.attr('placeholder')) {
          if (this.type === 'password') {
            i.addClass('password');
            this.type = 'text';
          }
          i.addClass('placeholder').val(i.attr('placeholder'));
        }
      }).blur().parents('form').submit(function () {
        $(this).find('[placeholder]').each(function () {
          i = $(this);
          if (i.val() === i.attr('placeholder')){
            i.val('');
          }
        });
      });
    }
  },

  // Normalize an event and return what is needed to operate on touch devices
  normalEvent: function(e){
    var uev = {}; // universal event to return
    uev.type = e.type; // good to have, but not used
    uev.currentTarget = e.currentTarget; // currentTarget seems to be the same cross platform
    if (e.type==="touchstart" || e.type==="touchmove" || e.type==="touchend"){
      // Touch events usually have an original event with a list of touches
      // For panels we only care about the first touch, because you would only
      // be dragging with one finger.
      if ((e.originalEvent &&
              e.originalEvent.touches &&
              e.originalEvent.touches.length>0) ||
          (e.touches &&
              e.touches.length>0)){
        var onetouch;
        if (e.touches){
          onetouch = e.touches[0];
        } else {
          onetouch = e.originalEvent.touches[0];
        }
        uev.clientX = onetouch.clientX;
        uev.clientY = onetouch.clientY;
      } else {
        // If it happens to have no original event, then just pull the clientX/Y
        uev.clientX = e.clientX;
        uev.clientY = e.clientY;
      }
    } else if (e.type==="mousedown" || e.type==="mouseup" || e.type==="mousemove"){
      uev.clientX = e.clientX;
      uev.clientY = e.clientY;
    } else if (e.type==="pointerdown" || e.type==="pointerup" || e.type==="pointermove" || e.type==="MSPointerMown" || e.type==="MSPointerMp" || e.type==="MSPointerMove"){ // microsoft or android events here...
      if (e.clientX && e.clientY){
        // Don't need to do anything if these exist
      } else {
        // set up the original event if available
        e = e.originalEvent;
      }
      uev.clientX = e.clientX;
      uev.clientY = e.clientY;
    }
    return uev;
  },

  stripTags: function(input) {
    return input.replace(/(<([^>]*)>)/ig, "");
  },

  isInIframe: function() {
    // Don't let us be iframeable unless we are an embedded reader!
    try{
      if (window.top.location.href){
        return false;
      } else {
        return true;
      }
    } catch(e){
      return true;
    }
  },

  refrainFromIframe: function(){
    // Don't let us be iframeable unless we are an embedded reader!
    if (Fraction.Helpers.Utils.isInIframe()){
      if (!Fraction.Brand.embeddable){
        // Get rid of this for now, but I'm very tired and not happy about it >:(
        // $('body').append("<div style='background:white;position:fixed;top:0;left:0;bottom:0;right:0;z-index:99;text-align:center;padding-top:100px;' id='noblock'><img src='/img/no.png' /><br /><span style='font-size:2.4rem;'>This is a warning that you will soon not be allowed to embed Fraction in this way.  In the future, please use the embeddable reader.  Thank you.<br /><br /><button id='noblockdismiss'>Dismiss</button></span></div>");
        // $("#noblockdismiss").click(function(){$("#noblock").remove()});
        try {
          Fraction.Reporter.gaEvent("iframe-illegal-embed", document.referrer || location.ancestorOrigins[0]);
        } catch (e){}
      }
    }
  },

  isScrolledIntoView: function(el, complete, windowEl) {
    if (el){
      var elemTop = el.getBoundingClientRect().top;
      var elemBottom = el.getBoundingClientRect().bottom;
      var top = 0;
      if (windowEl){
        top = $(windowEl).offset().top || 0;
      }
      var bottom = window.innerHeight;
      if (windowEl && windowEl.offsetHeight){
        bottom = windowEl.offsetHeight+top;
      }
      var isVisible;
      if (complete){
        isVisible = (elemTop >= top) && (elemBottom <= bottom);
      } else {
        isVisible = (elemBottom >= top) && (elemTop <= bottom);
      }
      return isVisible;
    }
    return false;
  },

  wasScrolledIntoView: function(el) {
    if (el) {
      const elemBottom = el.getBoundingClientRect().bottom;
      return elemBottom < 0;
    }
    return false;
  },

  runAfterRender: function(func){
    setTimeout(func,0);
  },

  // http://stackoverflow.com/questions/2490825/how-to-trigger-event-in-javascript
  fireEvent: function(eventName, data){
    var event; // The custom event that will be created

    if (document.createEvent) {
      event = document.createEvent("HTMLEvents");
      event.initEvent(eventName, true, true);
    } else {
      event = document.createEventObject();
      event.eventType = eventName;
    }

    event.eventName = eventName;
    $.extend(event, data);

    if (document.createEvent) {
      window.dispatchEvent(event);
    } else {
      window.fireEvent("on" + event.eventType, event);
    }
  },

  isBookshelfBrand: function(){
    return Fraction.Brand.brand === "Bookshelf Online";
  },

  focusOnElement: function(element){
    //setting element as var for scope issues
    var elId = element;
    setTimeout(function(){
      window.focus();
      if (elId) {
        $(elId).focus();
      }
     }, 4000);
  },

  getCurrentBrandUrl() {
    const paramBrand = Fraction.Helpers.getParameterByName('brand');
    let hostBrand = window.location.hostname;
    return paramBrand ? paramBrand : hostBrand;
  }

};

module.exports = Utils;
